/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMonthlyInterestCalculation} from '../api'

 export const useQueryGetMonthlyInterestCalculation = createReactQueryHook('getMonthlyInterestCalculation', getMonthlyInterestCalculation)
